module.exports = __webpack_public_path__ + "img/surrender_icon.826f219e.png";